import React, { useMemo, useEffect, useLayoutEffect, useState } from 'react';
import objectPath from 'object-path';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { useHtmlClassService } from '../../_core/MetronicLayout';
import { Topbar } from './Topbar';
import { useSubheader, getBreadcrumbsAndTitle } from '../../_core/MetronicSubheader';
import Filter from '../../../../app/components/common/Filter';
import { actions } from '../../../../app/modules/Dashboard/_redux/index'
import { api } from '../../../../redux/setupAxios';

export function Header() {
	const uiService = useHtmlClassService();
	const subheader = useSubheader();
	const location = useLocation();

	const [merchantPaymentPlan, setMerchantPaymentPlan] = useState(null);

	const layoutProps = useMemo(() => {
		return {
			headerClasses: uiService.getClasses('header', true),
			headerAttributes: uiService.getAttributes('header'),
			headerContainerClasses: uiService.getClasses('header_container', true),
			menuHeaderDisplay: objectPath.get(uiService.config, 'header.menu.self.display'),
		};
	}, [uiService]);
	const history = useHistory();
	const dispatch = useDispatch();

	const merchant = useSelector(state => state.merchants.merchants, shallowEqual)[0];
	const monthlySessionsCount = useSelector(state => state.dashboard.monthlySessionsCount, shallowEqual);

	useEffect(() => {
		if (!merchant) {
			return;
		}
		const getsessions = async () => {
			const date = new Date();
			const firstTsOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getTime();
			const res = await api.get(`statistic/count/${merchant.merchantId}/${firstTsOfMonth}`);
			dispatch(
				actions.updateSessionsCount(res.data.total),
			);
		}
		const hasSubscriptionMethod = merchant.shopify || merchant.plan;
		if (hasSubscriptionMethod && hasSubscriptionMethod.payment_status) {
			setMerchantPaymentPlan(hasSubscriptionMethod)
		};
		getsessions();
	}, [merchant, dispatch]);

	function clickPlan() {
		if (location.pathname === '/plans') {
			return;
		}
		history.push("/plans");
	}

	useLayoutEffect(() => {
		const aside = getBreadcrumbsAndTitle('kt_aside_menu', location.pathname);
		const header = getBreadcrumbsAndTitle('kt_header_menu', location.pathname);
		// subheader.setBreadcrumbs(aside.breadcrumbs || header.breadcrumbs);
		subheader.setTitle(aside.title || header.title);
		// eslint-disable-next-line
	}, [location.pathname]);

	useEffect(() => { }, [subheader]);

	return (
		<>
			{/*begin::Header*/}
			<div className={`header ${layoutProps.headerClasses}`} id='kt_header' {...layoutProps.headerAttributes}>
				{/*begin::Container*/}
				<div
					className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
				>
					{/* Info */}
					<div className='d-flex align-items-center flex-wrap mr-1'>
						<div className='d-flex align-items-center mr-5'>
							<h5 className='text-dark font-weight-bold my-2 mr-10 d-flex align-items-center'>
								{subheader.title}
							</h5>
							<Filter location={location.pathname} />
						</div>
						{merchantPaymentPlan ?
							<>
								<div className='mr-4'>{merchantPaymentPlan.plan} {monthlySessionsCount} Sessions
									|
									{merchant.billingInterval === 'ANNUAL' ? ' Yearly' : ' Monthly'}
								</div>
								<button
									onClick={clickPlan}
									type="button"
									style={{ backgroundColor: '#ff3300', color: 'white' }}
									className="btn">
									Upgrade
								</button>
							</>
							: null
						}
						<div className='mx-4'>Sessions this month: {monthlySessionsCount ?
							monthlySessionsCount.toLocaleString(navigator.language)
							: 0}
							{merchant?.monthlySessions ? `/${merchant?.monthlySessions}` : null}
						</div>
						{/* <BreadCrumbs items={subheader.breadcrumbs} /> */}
					</div>

					{/*begin::Topbar*/}
					<Topbar />
					{/*end::Topbar*/}
				</div>
				{/*end::Container*/}
			</div>
			{/*end::Header*/}
		</>
	);
}